module.exports = __webpack_public_path__ + "media/images/lb/039-19a487c7cc15e1306bcbb2c4becf5994.svg";